import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Field } from "@/components/site/FormControls";
import { adminApi, apiError } from "@/lib/api";
import { AdminShell } from "@/lib/adminAuth";

const Card = ({ title, children }) => (
  <AdminShell>
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="rounded-2xl border border-slate-200 bg-white p-8">
        <h1 className="font-display text-2xl font-bold text-[#0B132B]">{title}</h1>
        {children}
        <Link to="/admin/login" className="mt-6 block text-center text-sm text-slate-500 underline underline-offset-4">Back to sign in</Link>
      </div>
    </div>
  </AdminShell>
);

export function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await adminApi.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (ex) {
      toast.error(apiError(ex));
    }
  };

  return (
    <Card title="Reset password">
      {sent ? <p data-testid="forgot-sent" className="mt-4 text-sm text-slate-600">{sent}</p> : (
        <form onSubmit={submit} className="mt-6 grid gap-4">
          <Field label="Admin email" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required testid="forgot-email" />
          <button type="submit" data-testid="forgot-submit" className="rounded-full bg-[#0B132B] py-3 text-sm font-semibold text-white">Send reset link</button>
        </form>
      )}
    </Card>
  );
}

export function AdminResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await adminApi.post("/auth/reset-password", { token: params.get("token") || "", password });
      toast.success("Password updated. Please sign in.");
      navigate("/admin/login");
    } catch (ex) {
      toast.error(apiError(ex));
    }
  };

  return (
    <Card title="Choose a new password">
      <form onSubmit={submit} className="mt-6 grid gap-4">
        <Field label="New password (min 8 characters)" name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required testid="reset-password" />
        <button type="submit" data-testid="reset-submit" className="rounded-full bg-[#0B132B] py-3 text-sm font-semibold text-white">Update password</button>
      </form>
    </Card>
  );
}
